import * as swcHelpers from '@swc/helpers';
import { useInView } from 'react-intersection-observer';

var useWasSeenByUser = ()=>{
    const _ref = useInView({
        threshold: 0.75,
        triggerOnce: true
    }), { inView  } = _ref, rest = swcHelpers.objectWithoutProperties(_ref, [
        "inView"
    ]);
    return swcHelpers.objectSpread({}, rest, {
        wasSeen: inView
    });
};

export { useWasSeenByUser };
//# sourceMappingURL=use-was-seen-by-user.js.map
